
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockSetAssembleDtGrid extends Serenity.EntityGrid<IcStockSetAssembleDtRow, any> {
        protected getColumnsKey() { return IcStockSetAssembleDtColumns.columnsKey; }
        protected getDialogType() { return IcStockSetAssembleDtDialog; }
        protected getIdProperty() { return IcStockSetAssembleDtRow.idProperty; }
        protected getInsertPermission() { return IcStockSetAssembleDtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockSetAssembleDtRow.localTextPrefix; }
        protected getService() { return IcStockSetAssembleDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}